import { createContext, useContext } from 'react';
import { type Me } from '@kanos/web-core';

/**
 * The signed-in person, provided by `SessionGate`. In a module of its own: a hot reload of the
 * gate during development must not create a second context that the mounted provider does not
 * fill (`useMe() used outside SessionGate`).
 */
export const MeContext = createContext<Me | null>(null);

/** The signed-in person with an active firm; only inside `SessionGate`. */
export function useMe(): Me & { activeTenantId: string } {
  const me = useContext(MeContext);
  if (!me?.activeTenantId) throw new Error('useMe() used outside SessionGate');
  return { ...me, activeTenantId: me.activeTenantId };
}
